module.exports = __webpack_public_path__ + "static/media/siddharth-bannerghatta-zoo-trip-13.b081f2ec.png";